import * as React from 'react';
export const IcHighTemperatureOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21 11h-2a1 1 0 000 2h2a1 1 0 000-2zm-9-5a1 1 0 001-1V3a1 1 0 00-2 0v2a1 1 0 001 1zm5.66 1.76l1.41-1.42a1 1 0 10-1.41-1.41l-1.42 1.41a1.005 1.005 0 00.71 1.714 1.004 1.004 0 00.71-.294zM6 12a1 1 0 00-1-1H3a1 1 0 000 2h2a1 1 0 001-1zm5.31-4.93l5.62 5.62c.039-.228.062-.459.07-.69a5 5 0 00-5-5 5.2 5.2 0 00-.69.07zm-5 9.17l-1.38 1.42a1 1 0 101.41 1.41l1.42-1.41a1.004 1.004 0 00-1.42-1.42h-.03zM4.71 3.29a1.004 1.004 0 10-1.42 1.42l4.54 4.54a5 5 0 006.92 6.92l4.54 4.54a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095l-16-16zM12 18a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
